import { Component, OnInit } from '@angular/core';
import { PodcastService } from 'src/app/services/podcast.service';
import { ListStreamsI } from '../../base/list-streams/list-streams-i';
import { Observable } from 'rxjs';
import { Genre } from 'src/models/genre';
import { ActivatedRoute } from '@angular/router';
import { Stream } from 'src/models/stream';

@Component({
  selector: 'app-podcast-genres',
  templateUrl: './podcast-genres.component.html',
  styleUrls: ['./podcast-genres.component.scss']
})
export class PodcastGenresComponent implements OnInit, ListStreamsI {
  state$: Observable<object>;

  public categories = new Array<Genre>();

  public genreId: number;

  constructor(private activatedRoute: ActivatedRoute, private podcastService: PodcastService) {}

  ngOnInit() {
    this.podcastService.getGenres().subscribe((value: Genre[]) => {
      this.categories = value;
    });

    this.activatedRoute.queryParams.subscribe(params => {
      this.genreId = params['id'];
    });
  }

  public getHeadline(): string {
    const category = this.categories.find((category: Genre) => category.id === this.genreId);

    return category !== undefined ? category.name : 'Alle';
  }
  public getStreamsObservable(start: number, itemsPerPage: number): Observable<Stream[]> {
    const page = (start / itemsPerPage) + 1;
    const observable = this.genreId !== undefined ? this.podcastService.getTopPodcastsByGenre(this.genreId, page)
                                                    : this.podcastService.getTopGermanPodcasts(page);

    return observable;
  }

}